import * as React from 'react'
function SvgCurrencyMoney(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 8c1.2 0 2 .8 2 2v20c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2V10c0-1.2.8-2 2-2zm-7.6 4H13.8c-.8 2.8-3 5-5.8 5.8v4.4c2.8.8 5 3 5.8 5.8h12.4c.8-2.8 3-5 6-5.6v-4.6c-2.8-.8-5-3-5.8-5.8zM20 16a4 4 0 110 8 4 4 0 010-8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCurrencyMoney
